<template lang='pug'>
  
	div
		div.col-md-12.float-box-title

			h2.pull-left(v-if="registroVisualizacao")

				i.fa.fa-chevron-left.action-icon(@click="ocultarRegistro()", v-if="showReturnButton")

				i.mdi.mdi-map-marker(v-if="!showReturnButton")
				
				span(:title="registroVisualizacao.titulo") {{ registroVisualizacao.titulo || registroVisualizacao.nomeCamada }}

		div.float-box-content.default-padding.col-md-12#informacoesRegistro
			
			div(v-if="registroVisualizacao")
				div.form-group
					label Camada:
					p.form-control-static {{ registroVisualizacao.nomeCamada }}

				div.form-group(v-for="atr in registroVisualizacao.atributos",
						v-if="registroVisualizacao && registroVisualizacao.atributos && registroVisualizacao.atributos.length")
					label {{ atr.nome }}:
					p.form-control-static {{ atr.valor !== null ? atr.valor : '-' }}
		
				div.form-group(v-show="camada.possuiUrlMaisInformacoes")
					label 
						a(:href="urlMaisInformacoes", target="_blank") Mais informações

</template>

<script>

import camadasService from '@/services/camadasService';

export default {
	name: 'VisualizacaoRegistroCamada',

	componentOptions: {
		title: 'Visualização de registro',
		events: {
			'camada.exibirRegistro': 'init'
		}
	},

	props: {
		registro: Object,
		ignoreGlobalEvents: Boolean,
		showReturnButton: Boolean
	},

	data () {
		return {
			registroPesquisado: null
		};
	},

	methods: {

		ocultarRegistro () {
			this.$emit('close');
		},

		onFindRegistroComplete (registro) {

			this.registroPesquisado = registro;
		},

		init (options) {
			
			this.$emit('ocultarRegistro');
			this.registroPesquisado = null;

			var requestOptions = {
				lockElement: '#informacoesRegistro',
				lockMessage: 'Aguarde, buscando informações.'
			};

			camadasService.findRegistroById(options.registro.idCamada, options.registro.id, (data) => {

				this.onFindRegistroComplete(data);
			}, null, requestOptions);
		}
	},

	computed: {
		camada () {
			return this.registroVisualizacao && this.$store.getters.getCamada(this.registroVisualizacao.idCamada);
		},

		urlMaisInformacoes () {
			return this.registroVisualizacao &&
				camadasService.MAIS_INFORMACOES_URL
					.replace('{idCamada}', this.registroVisualizacao.idCamada)
					.replace('{idRegistro}', this.registroVisualizacao.id);
		},

		registroVisualizacao () {

			return this.registroPesquisado || this.registro;
		}
	}
};

</script>



// WEBPACK FOOTER //
// VisualizacaoRegistroCamada.vue?05a6a72d